/**
 * @module "model/template.object.model"
 */
define('formkit/model/template.object.model',['require','exports','module','backbone','./base.model','./rule.model','./answer.model','./template.object.type.model','../form'],function(require, exports, module) {
  //prettier-ignore
  var Backbone                = require('backbone'),
      BaseModel               = require('./base.model'),
      RuleModel               = require('./rule.model'),
      AnswerModel             = require('./answer.model'),
      TemplateObjectTypeModel = require('./template.object.type.model'),
      Form                    = require('../form');

  /**
   * @class TemplateObjectModel
   * @augments BaseModel
   * @see {@link model/base.model.js}
   * @property {Object} childModels - a object containing, rules, children, custom,
   * answer, and type.
   */
  var TemplateObjectModel = BaseModel.extend({
    /**
     * @method defaults
     * @returns {Object} an object containing defaults for name, text, label,
     * type, description, required, helpText, custom, children, and rules.
     */
    defaults: function() {
      return {
        name: '',
        text: null,
        label: '',
        type: null,
        description: '',
        dataLabel: null,
        required: false,
        helpText: '',
        custom: {},
        children: [],
        rules: [],
        dataLabelsCollection: null,
      };
    },

    childModels: {
      dataLabel: BaseModel,
      rules: RuleModel,
      children: null,
      custom: BaseModel,
      answer: AnswerModel,
      type: TemplateObjectTypeModel,
    },

    initialize: function() {
      BaseModel.prototype.initialize.apply(this, arguments);

      if (!!this.get('type') && !!this.get('type').get('dataLabels')) {
        this.setDataLabelsCollection();

      } else {
        this.once('type:change', function() {
          this.setDataLabelsCollection();
        });
      }

      // flag any current data labels as "selected" in the dataLabelsCollection on page load
      this.syncDataLabelSelectionWithCollection();
    },

    setDataLabelsCollection: function() {
      this.set('dataLabelsCollection', new Backbone.Collection(this.get('type').get('dataLabels')));
    },

    syncDataLabelSelectionWithCollection: function() {
      var selectedDataLabel = this.get('dataLabel') ? this.findSelectedDataLabelModelByValue(this.getDataLabelValue()) : null;

      if (selectedDataLabel) {
        selectedDataLabel.set({ selected: true });
      }
    },

    getDataLabelValue: function() {
      return this.get('dataLabel').get('value');
    },

    getDataLabelsCollection: function() {
      return this.get('dataLabelsCollection');
    },

    findSelectedDataLabelModelByValue: function(value) {
      return this.getDataLabelsCollection().findWhere({ value: value });
    },

    /**
     * @method relationships
     *
     * @returns {Object} The form's relationships for its TemplateObjectModel
     */
    relationships: function() {
      return Form.getModelRelationships('TemplateObjectModel');
    },
  });

  TemplateObjectModel.prototype.childModels.children = TemplateObjectModel;

  module.exports = TemplateObjectModel;
});

